// extracted by mini-css-extract-plugin
export var cardIcon = "_b3-4";
export var checkboxCard = "_b3-0";
export var checkboxCardSelected = "_b3-3";
export var disabled = "_b3-1";
export var outerBorder = "_b3-2";
export var spacerMedium = "_b3-7";
export var spacerSmall = "_b3-6";
export var spacerXsmall = "_b3-5";